"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const types_1 = require("./types");
const Inner_1 = require("./Inner");
const Loader_1 = require("./Loader");
const template_parser_1 = require("@osmosys/template-parser");
const getViewFromPath_1 = require("./getViewFromPath");
const defaultPreferences = {
    codeMode: false,
    codeModeSize: 'sm',
    view: types_1.EMAIL_MAKER_DEFAULT_VIEW_ID,
};
const onQueryChange = (context, isReady) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { canvasQueries, state, pathParams, meta, prefs } = context;
    const newView = getViewFromPath_1.getViewFromPath(pathParams.view);
    const isCreating = pathParams.emailNumber === 'new';
    if (isCreating) {
        return {
            meta,
            prefs: Object.assign(Object.assign({}, prefs), { view: 'new' }),
            ready: true,
            state,
        };
    }
    const emailData = (_d = (_c = (_b = (_a = canvasQueries) === null || _a === void 0 ? void 0 : _a.email) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.email;
    if (!isReady || !emailData) {
        return {
            meta,
            prefs: Object.assign(Object.assign(Object.assign({}, defaultPreferences), prefs), { view: newView }),
            ready: false,
            state,
        };
    }
    const hasName = emailData && emailData.name;
    const originalHTML = (_f = (_e = emailData) === null || _e === void 0 ? void 0 : _e.emailTemplateVersion) === null || _f === void 0 ? void 0 : _f.html;
    const isHighlighted = template_parser_1.emailTemplateBlocksAre((_h = (_g = state) === null || _g === void 0 ? void 0 : _g.draftEmail) === null || _h === void 0 ? void 0 : _h.blocks, 'highlighted');
    const newState = Object.assign(Object.assign({ activeContentImportBlockIdx: null, activeConversionBlockIdx: null, contentRefreshModalIsOpen: false, disableEditEmailButtonOnCampaignSendPageButton: false }, state), { conversionPanelConversions: Object.assign({}, state.conversionPanelConversions), displayName: emailData && hasName && emailData.name
            ? emailData.name
            : emailData && emailData.emailNumber
                ? `Email #${emailData.emailNumber}`
                : 'New email', draftEmail: Object.assign(Object.assign({}, emailData), { originalHTML }), isHighlighted, link: path => {
            return `/emails/${pathParams.emailNumber}${path ? `/${path.replace(/^\//, '')}` : ''}`;
        }, sourceEmail: Object.assign(Object.assign({}, emailData), { originalHTML }) });
    const templateVersion = emailData && emailData.emailTemplateVersion;
    const template = (_k = (_j = emailData) === null || _j === void 0 ? void 0 : _j.emailTemplateVersion) === null || _k === void 0 ? void 0 : _k.template;
    const hasBothTemplateAndVersion = templateVersion && template;
    const hasProdVersion = !!(hasBothTemplateAndVersion && template.productionVersion);
    const hasStagingVersion = !!(hasBothTemplateAndVersion && template.stagingVersion);
    return {
        meta: {
            canUpgradeToProdTemplateVersion: !!(hasProdVersion &&
                templateVersion.version !== template.productionVersion.version),
            canUpgradeToStageTemplateVersion: !!(hasStagingVersion &&
                templateVersion.version !== template.stagingVersion.version &&
                (!template.productionVersion ||
                    template.productionVersion.version !==
                        template.stagingVersion.version)),
        },
        prefs: Object.assign(Object.assign(Object.assign({}, defaultPreferences), prefs), { view: newView }),
        ready: true,
        state: newState,
    }; // TODO: REMOVE ANY
};
const onRouteChange = ({ pathParams, prefs }) => {
    const newView = getViewFromPath_1.getViewFromPath(pathParams.view);
    return {
        prefs: Object.assign(Object.assign(Object.assign({}, defaultPreferences), prefs), { view: newView }),
    }; // TODO: REMOVE ANY
};
exports.EmailCanvas = () => {
    return (react_2.default.createElement(react_1.OsmosysCanvasPage, { defaultContextState: undefined, defaultPrefs: defaultPreferences, onRouteChange: onRouteChange, onQueryChange: onQueryChange },
        react_2.default.createElement(Loader_1.EmailCanvasLoader, null),
        react_2.default.createElement(react_1.OsmosysCanvasPageReadyState, null,
            react_2.default.createElement(Inner_1.EmailCanvasInner, null)),
        react_2.default.createElement(react_1.OsmosysCanvasPageLoadingState, null),
        react_2.default.createElement(react_1.OsmosysCanvasPageUndesiredState, null)));
};
exports.default = exports.EmailCanvas;
//# sourceMappingURL=index.js.map